import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import {
  warehouseApi,
  type LayoutDto,
  type WarehousePage,
  type WarehouseQuery,
} from '../api/warehouse.api.js';

/**
 * Ombor so'rovlari bitta joyda: kalitlar ham shu yerda turadi, shuning uchun
 * mutatsiyadan keyin `invalidateQueries({ queryKey: warehouseKeys.all })`
 * hamma joyda bir xil ishlaydi va kalit ikki faylda ayri ketmaydi.
 */
export const warehouseKeys = {
  all: ['warehouse'] as const,
  list: (query: WarehouseQuery) => ['warehouse', 'list', query] as const,
  layout: (id: string | null) => ['warehouse', 'layout', id] as const,
};

export interface WarehouseListOptions {
  /**
   * `false` bo'lsa so'rov ketmaydi. Ro'yxat ba'zan faqat FILTR uchun kerak
   * bo'ladi (masalan qoldiq qidiruvida) — ombor allaqachon ma'lum bo'lgan
   * ekranda esa filtr chizilmaydi va 200 ta ombor bekorga so'ralmasin.
   */
  enabled?: boolean;
}

export const useWarehouses = (
  query: WarehouseQuery = {},
  options: WarehouseListOptions = {},
): UseQueryResult<WarehousePage> =>
  useQuery({
    queryKey: warehouseKeys.list(query),
    queryFn: () => warehouseApi.list(query),
    enabled: options.enabled ?? true,
  });

/**
 * Butun daraxt (zona → stellaj → katak) bitta so'rovda keladi va 3D sahna ham,
 * ro'yxat ham AYNAN shu ma'lumotdan chiziladi. `staleTime` uzun: tuzilma kunda
 * bir-ikki marta o'zgaradi, kataklar holati esa mutatsiyadan keyin qo'lda
 * yangilanadi — har fokusda mingta katak qayta yuklanmaydi.
 */
export const useWarehouseLayout = (warehouseId: string | null): UseQueryResult<LayoutDto> =>
  useQuery({
    queryKey: warehouseKeys.layout(warehouseId),
    queryFn: () => warehouseApi.layout(warehouseId ?? ''),
    enabled: warehouseId !== null,
    staleTime: 60_000,
  });
